// Druckblätter im Browser (Fahrerabrechnung, Zusammenfassung der Verkäufe; Kundenwunsch 13.10.2026: „selbes layout wie
// bei der fahrerabrechnung“ und „im browser statt backend“). Gemeinsam: das Aussehen des Blatts (SHEET_CSS, Klassen
// .ds-*; gilt für die Vorschau der Fahrerabrechnung und für das Druck-iframe), die Druckregeln (PRINT_CSS: A4 hoch, je
// Blatt eine Seite, Fußzeile unten), das Briefkopf-Logo aus der Logo-Verwaltung und der Druck über ein unsichtbares
// iframe (gedruckt wird erst, wenn die Bilder geladen sind). Druckfarben bleiben fest (Papier, kein Farbschema).
import axios from "axios";

export const SHEET_CSS = `
.ds-sheet { box-sizing: border-box; display: flex; flex-direction: column; background: #fff; color: #1f2328; font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 12px; line-height: 1.4; padding: 28px 32px; max-width: 760px; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
.ds-sheet * { box-sizing: border-box; }
.ds-letterhead { display: flex; justify-content: space-between; align-items: center; gap: 24px; padding-bottom: 6px; }
.ds-logo { display: block; max-height: 56px; max-width: 220px; object-fit: contain; }
.ds-brand-name { font-size: 18px; font-weight: 700; }
.ds-company { text-align: right; font-size: 10.5px; color: #57606a; }
.ds-company-name { font-size: 12px; font-weight: 700; color: #1f2328; }
.ds-intro { margin: 22px 0 16px; }
.ds-eyebrow { font-size: 10px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #57606a; }
.ds-title { font-size: 24px; font-weight: 700; line-height: 1.2; margin: 2px 0 8px; }
.ds-meta { display: flex; flex-wrap: wrap; gap: 4px 18px; font-size: 11px; color: #57606a; }
.ds-meta b { font-weight: 600; color: #1f2328; margin-right: 4px; }
/* „Erstellt“ immer in eigener Zeile: alle Blätter gleich hoch, egal wie lang Zeitraum und Benutzer sind */
.ds-meta .ds-meta-line { flex-basis: 100%; }
.ds-kpis { display: flex; margin-bottom: 18px; border: 1px solid #c9d1d9; }
.ds-kpi { flex: 1; border-left: 1px solid #c9d1d9; }
.ds-kpi:first-child { border-left: none; }
.ds-kpi span { display: block; padding: 5px 10px; font-size: 10px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: #57606a; background: #f0f2f4; border-bottom: 1px solid #c9d1d9; }
.ds-kpi strong { display: block; padding: 7px 10px; font-size: 16px; font-variant-numeric: tabular-nums; white-space: nowrap; }
.ds-kpi-main { flex: 1.4; }
.ds-kpi-main span { color: #1f2328; background: #dfe3e8; }
.ds-kpi-main strong { font-size: 19px; }
.ds-table { width: 100%; border-collapse: collapse; border: 1px solid #c9d1d9; }
.ds-table th, .ds-table td { padding: 5px 8px; text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; border: 1px solid #c9d1d9; }
.ds-table th { font-size: 10px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: #57606a; background: #f0f2f4; }
.ds-table td:last-child { font-weight: 600; }
.ds-table .ds-left { text-align: left; }
.ds-table tr.ds-empty td { color: #a0a7b0; font-weight: 400; }
.ds-table tfoot td { font-weight: 700; background: #dfe3e8; }
.ds-section { margin: 18px 0 6px; font-size: 10px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #57606a; }
.ds-filter { margin: -8px 0 16px; font-size: 11px; color: #57606a; white-space: normal; }
.ds-filter b { font-weight: 600; color: #1f2328; margin-right: 4px; }
.ds-fields { width: 100%; border-collapse: collapse; margin-bottom: 18px; }
.ds-fields th, .ds-fields td { padding: 7px 10px; text-align: left; border-bottom: 1px solid #e1e4e8; vertical-align: top; }
.ds-fields th { width: 34%; font-size: 10px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: #57606a; }
.ds-fields td { font-size: 13px; }
.ds-sign { display: flex; gap: 32px; margin-top: 36px; }
.ds-sign div { flex: 1; padding-top: 6px; border-top: 1px solid #1f2328; font-size: 10px; color: #57606a; }
.ds-footer { display: flex; flex-direction: column; align-items: flex-end; gap: 3px; margin-top: 28px; padding-top: 16px; font-size: 9.5px; color: #8c959f; text-align: right; break-inside: avoid; page-break-inside: avoid; }
.ds-sima-logo { display: block; height: 16px; width: auto; }
`;

// Ein Blatt je A4-Seite, die Fußzeile sitzt unten auf der Seite; lange Tabellen laufen über mehrere Seiten. Die
// Mindesthöhe bleibt unter der nutzbaren Seitenhöhe (297 − 2 × 12 mm), damit die Fußzeile nicht auf eine zweite Seite
// rutscht; sie wird nie geteilt und hält Abstand zum Inhalt (Kundenwunsch 13.10.2026).
export const PRINT_CSS = `
@page { size: A4 portrait; margin: 12mm; }
html, body { margin: 0; background: #fff; }
.ds-sheet { padding: 0; max-width: none; min-height: 265mm; page-break-after: always; break-after: page; }
.ds-sheet:last-child { page-break-after: auto; break-after: auto; }
.ds-footer { margin-top: auto; }
.ds-table tr { page-break-inside: avoid; }
.ds-table thead { display: table-header-group; }
`;

const LETTERHEAD_LOGO = /^briefkopf\.(png|jpe?g)$/i;

// SIMA-Logo der Fußzeile, absolut, damit es auch im Druck-iframe aufgelöst wird
export function simaPrintLogoUrl() {
  return `${window.location.origin}${process.env.BASE_URL}img/logo-sima-print.svg`;
}

// Briefkopf-Logo: Datei „briefkopf.png“ (oder .jpg) aus der Logo-Verwaltung. Die Download-URL ist signiert und läuft
// ab, daher vor jedem Druck neu holen. Ohne Logo (oder bei Fehler) null. `pattern`: anderer Dateiname für einen
// weiteren Briefkopf (Quittung, src/components/payments/receiptLetterheads.js).
export async function loadLetterheadLogo(baseUrl, pattern) {
  try {
    const files = (await axios.get(`${baseUrl}logo`)).data || [];
    const file = files.find(f => (pattern || LETTERHEAD_LOGO).test(f.name));
    return file
      ? (await axios.get(`${baseUrl}logo?file_name=${encodeURIComponent(file.name)}`)).data.downloadUrl
      : null;
  } catch (error) {
    return null;
  }
}

// Kundendaten für den Briefkopf (Name, Webadresse, Telefon): aus dem Store, sonst einmal von der Schnittstelle
export async function loadCustomer(store) {
  if (store.state.customer) {
    return store.state.customer;
  }
  try {
    return (await axios.get(`${store.state.baseUrl}customer`)).data;
  } catch (error) {
    return null;
  }
}

// Briefkopf aus den Kundendaten
export function letterheadOf(customer, fallbackName) {
  const url = customer && customer.customer_url;
  return {
    name: (customer && customer.cust_printname) || fallbackName || "",
    url: url ? url.replace(/^https?:\/\//, "").replace(/\/$/, "") : "",
    tel: (customer && customer.customer_tel) || ""
  };
}

// Blätter (HTML der .ds-sheet-Elemente) in einem unsichtbaren iframe drucken; erst wenn die Bilder geladen sind
export async function printSheetsHtml(html, title) {
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(`<!doctype html><html lang="de"><head><meta charset="utf-8"><title>${title}</title>
    <style>${SHEET_CSS}${PRINT_CSS}</style></head><body>${html}</body></html>`);
  doc.close();
  await Promise.all(Array.from(doc.images).map(img => (img.complete ? null : new Promise(resolve => {
    img.onload = resolve;
    img.onerror = resolve;
  }))));
  iframe.contentWindow.focus();
  iframe.contentWindow.print();
  setTimeout(() => document.body.removeChild(iframe), 1000);
}
